import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.update-vorlagen-mandant-options';
import * as api from '../../../clients/vorlagen';

@Injectable()
export class VorlagenUpdateVorlagenMandantOptionsEffects {

    UpdateVorlagenMandantOptions$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_UPDATE_VORLAGEN_MANDANT_OPTIONS),
        mergeMap((x: ac.PostUpdateVorlagenMandantOptionsAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postUpdateVorlagenMandantOptions(x.vorlagenMandantOptions).pipe(
                map((result: any) => {
                    return new ac.PostUpdateVorlagenMandantOptionsErfolgreichAction(x.vorlagenMandantOptions, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostUpdateVorlagenMandantOptionsFehlerAction(error, x.vorlagenMandantOptions, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.VorlagenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.VorlagenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.VorlagenCommandService);
        }
        return this.service;
    }
}
